import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Download } from "lucide-react";
import { COMPANY } from "../content";
import { useLanguage } from "../i18n";

const Footer = () => {
  const { lang, t, data } = useLanguage();

  return (
    <footer className="bg-[#101733] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <span className="inline-flex bg-white rounded-md px-3 py-2 mb-5">
              <img src={COMPANY.logo} alt="INEXPONENS" className="h-12 w-auto object-contain" />
            </span>
            <p className="text-white/60 text-sm leading-relaxed font-light">{t.footerDesc}</p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-[#6ea8ff] mb-5">{t.footerServices}</h4>
            <ul className="space-y-3">
              {data.services.map((s) => (
                <li key={s.id}>
                  <Link
                    to="/services"
                    onClick={() => window.scrollTo({ top: 0 })}
                    className="text-white/70 hover:text-white text-sm transition-colors duration-300"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Liens */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-[#6ea8ff] mb-5">{t.footerCabinet}</h4>
            <ul className="space-y-3">
              {t.nav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => window.scrollTo({ top: 0 })}
                    className="text-white/70 hover:text-white text-sm transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="/plaquette-inexponens.pdf"
                  download="Plaquette-INEXPONENS.pdf"
                  className="inline-flex items-center gap-2 text-[#6ea8ff] hover:text-white text-sm font-medium transition-colors duration-300"
                  data-testid="footer-brochure-link"
                >
                  <Download size={14} />
                  {t.brochure}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-[#6ea8ff] mb-5">{t.footerContact}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/70">
                <MapPin size={17} className="text-[#6ea8ff] mt-0.5 shrink-0" />
                <span>{lang === "fr" ? COMPANY.address : COMPANY.addressEn}</span>
              </li>
              <li>
                <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-300">
                  <Phone size={17} className="text-[#6ea8ff] shrink-0" />
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-300">
                  <Mail size={17} className="text-[#6ea8ff] shrink-0" />
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <Clock size={17} className="text-[#6ea8ff] mt-0.5 shrink-0" />
                <span>{t.footerHours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs tracking-wide">
            © {new Date().getFullYear()} {COMPANY.fullName} — {t.footerRights}
          </p>
          <p className="text-white/50 text-xs tracking-wide">{COMPANY.website}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
